import React from 'react';

const StoreIcon = ({ active }) => {
  return (
    <svg id="store_black_24dp" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
      <path id="Path_6126" data-name="Path 6126" d="M0,0H24V24H0Z" fill="none" />
      <path
        id="Path_6127"
        data-name="Path 6127"
        d="M18.36,9l.6,3H5.04l.6-3H18.36M20,4H4V6H20Zm0,3H4L3,12v2H4v6H14V14h4v6h2V14h1V12ZM6,18V14h6v4Z"
        fill={active ? '#58B9C1' : '#ededed'}
      />
    </svg>
  );
};

export default StoreIcon;
